import { rayCastThroughPortals } from '../guns/portalPhysicsQuery.js';

// Portals one beam can pass through, so two facing portals cannot loop it forever.
const MAX_PORTAL_CROSSINGS = 4;

const start = new Box2D.b2Vec2();
const end = new Box2D.b2Vec2();

// The beam from (x, y) along (dx, dy) as straight stretches: one into each
// linked portal it enters and one out of the other, `range` long in all. The
// last ends on the first fixture `blocks` accepts.
export const beamPath = (world, x, y, dx, dy, range, blocks) => {
	start.Set(x, y);
	end.Set(x + dx * range, y + dy * range);
	const result = rayCastThroughPortals(Box2D, world, start, end, {
		acceptFixture: blocks,
		maxCrossings: MAX_PORTAL_CROSSINGS,
		includeMissTrace: true,
	});
	const points = [{x, y}];
	for (const crossing of result?.crossings || []) points.push(crossing.entryPoint, crossing.exitPoint);
	points.push(result?.point || {x: x + dx * range, y: y + dy * range});
	const beams = [];
	let direction = {dx, dy};
	for (let i = 0; i < points.length; i += 2) {
		const from = points[i];
		const to = points[i + 1];
		const length = Math.hypot(to.x - from.x, to.y - from.y);
		if (length > 1e-6) direction = {dx: (to.x - from.x) / length, dy: (to.y - from.y) / length};
		beams.push({x: from.x, y: from.y, ...direction, length, blocked: false, hit: null});
	}
	if (result?.fixture) {
		const last = beams[beams.length - 1];
		last.blocked = true;
		last.hit = result.fixture.GetBody();
	}
	return beams;
};
